export default [
    { id: 1, description: 'Chairlift' },
    { id: 4, description: 'Gondola' },
    { id: 3, description: 'Cable Car' },
    { id: 2, description: 'Mixed Lift' },
    { id: 5, description: 'Drag Lift' },
    { id: 6, description: 'T-Bar' },
    { id: 7, description: 'J-Bar' },
    { id: 8, description: 'Platter' },
    { id: 9, description: 'Rope Tow' },
    { id: 0, description: 'Unknown ' },
];



// WEBPACK FOOTER //
// ./src/common/LiftTypeData.js